import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Select,
    Table,
    Tag,
    Radio,
    Tabs,Spin,
    Badge, Popconfirm, notification
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";

const {Title, Text} = Typography;
const {Content} = Layout;
const {RangePicker} = DatePicker;
const { TabPane } = Tabs;
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '结算完成',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const openNotification1 = () => {
    notification.open({
        message: '不可扎账',
        description:
            '未到改月扎账日期',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const onGo = (id) => {
    window.location.href="/pagefinsetshis"
};
const Go = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        let day = moment().format('DD')
        if(id.date.format('YYYY-MM') >= moment().format('YYYY-MM')){
            openNotification1()
        }else{

        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            function queryParse(query){
                let queryText = "";
                for(let key in query){
                    queryText += `${key}=${query[key]}&`;
                }
                return queryText.slice(0,-1);
            }
            var list = {};
            list.fund_date = id.date.format('YYYY-MM') + '-26';
            list.fund_value = id.value ? id.value : 0;
            list.fund_num = id.num ? id.num : 0;
            list.fund_type = 0;
            list.fund_intro = '扎账结算';
            list.fund_client = id.id;
            list.fund_admin = id.admin ? id.admin : 1;

            fetch("https://pd.pokemonbye.com:8084/api/insertsellfund",
                {
                    method:'post',
                    body:queryParse(list),
                    headers:{
                        'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        //window.location.reload();
                        openNotification();
                        window.location.href="/pagefinsetshis?id=" + id.id
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }, 1000);
        }
    };
    const handleCancel = () => {

        setOpen(false);
    };
    return (
        <Popconfirm
            title="确认扎账？扎账后无法撤回。"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button type="primary" onClick={showPopconfirm}>
                结算
            </Button>
        </Popconfirm>
    );
};
const columns = (that) => [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '编号',
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: '采购单位',
        dataIndex: 'buyer',
        key: 'buyer',
    },
    {
        title: '类型',
        dataIndex: 'stock',
        key: 'stock',
        filters: that.state.optionsb,
        onFilter: (value, record) => record.stock.startsWith(value),
    },
    {
        title: '车牌',
        dataIndex: 'car',
        key: 'car',
    },
    {
        title: '单价（元/吨）',
        dataIndex: 'price',
        key: 'price',
        sorter: (a, b) => a.price - b.price,
        render: (price) => <p>{price ? (price/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '净重（吨）',
        dataIndex: 'value',
        key: 'value',
        sorter: (a, b) => a.value - b.value,
        render: (value) => <p>{value ? (value/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '金额（元）',
        dataIndex: 'max',
        key: 'max',
        sorter: (a, b) => a.max - b.max,
        render: (max) => <p>{max ? (max/1).toFixed(2) : '0.00'}</p>,
    },
    {
        title: '时间',
        dataIndex: 'time',
        key: 'time',
        render: (time) => <p>{time ? time.substring(0,19) : '0.00'}</p>,
    }
];

const Load = (that,start,end) => {

    fetch("https://pd.pokemonbye.com:8084/api/getsellclient")
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].value = array[i].id;
                        array[i].label = array[i].name;
                    }
                    that.setState({
                        isLoaded: true,
                        options: array
                    });
                }
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Load2 = (that,id,month) => {

    fetch("https://pd.pokemonbye.com:8084/api/getsellclientpricebyid?id=" + id)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){
                    that.setState({
                        isLoaded: true,
                        sum: array[0]
                    });
                    fetch("https://pd.pokemonbye.com:8084/api/getsellpickpricebyclient?start="+month+"-01&end="+month+"-31&id=" + id)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let array = result.data;
                                let max = 0;
                                let num = 0;
                                if(array!=null&&array.length>0){
                                    for (let i = 0; i < array.length; i++) {
                                        array[i].key = i + 1;
                                        if(array[i].pick_value == null){
                                            if(that.state.sum.clientprice_value != 0){

                                                array[i].pick_value = that.state.sum.clientprice_value;
                                            }else{

                                                array[i].pick_value = 440;
                                            }
                                        }
                                        array[i].sum = array[i].pick_num * array[i].pick_value;
                                        max += array[i].sum;
                                        num += array[i].pick_num * 1;
                                    }
                                    max = max ? (max/1).toFixed(2) : '0.00'
                                    num = num ? (num/1).toFixed(2) : '0.00'
                                }
                                that.setState({
                                    isLoaded: true,
                                    list: array,
                                    listlength: array.length,
                                    max: max,
                                    num: num
                                });
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {
                                that.setState({
                                    isLoaded: true,
                                    error
                                });
                            }
                        )
                }
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Load3 = (that,id,name,start,end) => {
    that.setState({
        loading: true
    });

    fetch("https://pd.pokemonbye.com:8081/api/getweightmaxbyname?name=" + name + "&start=" + start + "&end=" + end)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                var sumvalue = 0
                if(array!=null&&array.length>0){
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1
                        sumvalue += parseFloat(array[i].value)
                    }
                }
                that.setState({
                    isLoaded: true,
                    sumvalue: sumvalue.toFixed(2),
                    sum: array.length
                });

                fetch("https://pd.pokemonbye.com:8084/api/getsellclientdate?client=" + id + "&start=" + start + "&end=" + end)
                    .then(res => res.json())
                    .then(
                        (result) => {
                            var summax = 0
                            if(result!=null&&result.length>0){
                                for (let i = 0; i < array.length; i++) {
                                    for (let j = 0; j < result.length; j++) {
                                        if(array[i].time.substring(0,10) == result[j].date){
                                            for(let k = 0; k < result[j].list.length; k++){
                                                if(array[i].stock == result[j].list[k].stockname){
                                                    array[i].price = result[j].list[k].value
                                                    array[i].max = array[i].price * array[i].value
                                                }
                                            }
                                        }
                                    }
                                    summax += array[i].max
                                }

                            }
                            that.setState({
                                loading: false,
                                pricelist: result,
                                list: array,
                                summax: summax.toFixed(2),
                            });
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            that.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
    fetch("https://pd.pokemonbye.com:8084/api/getsellfundlikeintrobyclient?intro=扎账结算" + "&client=" + id + "&month=" + start.slice(0, -2) + "-26")
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if(array!=null&&array.length>0){

                }else{
                    array = ''
                }
                that.setState({
                    isLoaded: true,
                    islocked: array
                });
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}
const disabledDate = (current) => {
    let day = moment().format('DD')/*
    if(day < 26) {

        return current < moment('2023-12').endOf('month') || current > moment().endOf('month');
    }else{

        return current < moment('2023-12').endOf('month') || current > moment().add(1, 'months').endOf('month');
    }*/
    return current < moment('2023-12').endOf('month') || current > moment().endOf('month');
};

class PageFinSets extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const userId = cookie.load('userId');/*
        let start = moment().subtract(1, 'months').format('YYYY-MM') + '-26'
        let end = moment().format('YYYY-MM') + '-26'*/
        let start = moment().format('YYYY-MM') + '-01'
        let end = moment().add(1, 'months').format('YYYY-MM') + '-01'
        this.state = {
            title: "财务扎账",
            county: [],
            list: [],
            userid: userId,
            listman: [],
            listcus: [],
            options: [],
            selid: 0,
            selname: '',
            islocked: '',
            sum: 0,
            max: 0,
            num: 0,
            summax: 0,
            sumvalue: 0,
            month: moment(),
            start: start,
            end: end,
            loading: false,
            optionsb: []
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].text = array[i].stockname;
                            array[i].value = array[i].stockname;
                        }
                        this.setState({
                            isLoaded: true,
                            optionsb: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        Load(this);
        //Load2(this,this.state.selid,this.state.month);

    }

    render() {
        const handleChange = (value) => {
            let options = this.state.options
            let name = '';

            for (let i = 0; i < options.length; i++) {
                if(options[i].value == value){
                    name = options[i].label
                }
            }
            this.setState({
                selid: value,
                selname: name
            });
            //Load2(this,value,this.state.month);
            Load3(this,value,name,this.state.start,this.state.end)
        };
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            getCheckboxProps: (record) => ({
                disabled: record.name === 'Disabled User',
                // Column configuration not to be checked
                name: record.name,
            }),
        };
        const onChange = (date, dateString) => {
            let start = date.format('YYYY-MM') + '-01'
            let end = date.add(1, 'months').format('YYYY-MM') + '-01'
            console.log(date)
            this.setState({
                start: start,
                end: end,
                month: date
            });
            date.subtract(1, "months").format('YYYY-MM');
            Load3(this,this.state.selid,this.state.selname,start,end);
        };
        return (
            <div>
                <Leftmenu/>
                <div className="mainpanel">
                    <Header/>
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                                subTitle="账期为本月1日至最后一日"
                            >
                                <Spin spinning={this.state.loading}>
                                <Space>
                                    <Select
                                        defaultValue="请选择"
                                        style={{
                                            width: 220,
                                        }}
                                        onChange={handleChange}
                                        options={this.state.options}
                                    />
                                    <DatePicker defaultValue={this.state.month} onChange={onChange} picker="month" disabledDate={disabledDate}/>
                                    {
                                        this.state.islocked?
                                            <Button disabled>已结算</Button>
                                            :
                                            this.state.selid?
                                            <Go id={this.state.selid} value={this.state.summax} date={this.state.month} admin={this.state.userid} num={this.state.sumvalue}>扎账</Go>
                                                :
                                                <></>
                                    }
                                    <Button onClick={() => onGo()}>
                                        历史
                                    </Button>
                            </Space>
                                <br/>
                                <br/>
                                <Descriptions bordered>
                                    <Descriptions.Item label="总单量" span={1}>{this.state.sum}</Descriptions.Item>
                                    <Descriptions.Item label="总重量（吨）" span={1}>{this.state.sumvalue}</Descriptions.Item>
                                    <Descriptions.Item label="总金额（元）" span={1}>{this.state.summax}</Descriptions.Item>
                                </Descriptions>
                                <br/>

                                <Table bordered={true} columns={columns(this)} dataSource={this.state.list} rowSelection={{
                                    type: 'checkbox',
                                    ...rowSelection,
                                }}
                                       pagination={{
                                           pageSize: 100,
                                       }}/>
                                </Spin>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageFinSets;


